import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  isOpenedPrevious = false;
  public openTemplateRegisterSubject: BehaviorSubject<{
    open: boolean;
    data?: {
      from: string;
      section_name: string;
      is_my_data: boolean;
      nameForm: string;
      folderId: number | null;
      subFolderId: number | null;
      userId: string;
      source: string;
      selectedVaultData: any;
    };
  }> = new BehaviorSubject({ open: false, data: undefined });

  openTemplateRegister(
    open: boolean,
    data?: {
      from: string;
      section_name: string;
      is_my_data: boolean;
      nameForm: string;
      folderId: number | null;
      subFolderId: number | null;
      userId: string;
      source: string;
      selectedVaultData: any;
    }
  ) {
    this.openTemplateRegisterSubject.next({ open, data });
  }
}
